module.exports = __webpack_public_path__ + "static/media/scan-product-aramark.3bee5769.png";